<template>
  <div style="padding: 10px;background-color: #fff;">
    <el-table
        :data="inspectionReportVOS"
        border
        stripe
        size="mini"
        style="width: 100%">
      <el-table-column prop="no" width="150" align="center" label="检验编号"/>
      <el-table-column prop="materialNo" width="100" align="center" label="物料编号"/>
      <el-table-column prop="mappingMaterialNo" width="100" align="center" label="旧物料号"/>
      <el-table-column prop="materialName" min-width="150" align="center" label="物料名称"/>
      <el-table-column prop="purchaseOrderNo" width="130" align="center" label="采购单号"/>
      <el-table-column prop="purchaseOrderRowNo" width="80" align="center" label="行号"/>
      <el-table-column prop="factoryNo" width="100" align="center" label="pc号"/>
      <el-table-column prop="submissionNum" width="90" align="center" label="送检数量"/>
      <el-table-column prop="spotCheckNum" width="90" align="center" label="抽检数量"/>
      <el-table-column prop="unqualifiedNum" width="120" align="center" label="抽检不合格数量"/>
      <el-table-column prop="badQuality" width="90" align="center" label="不良数量"/>
      <el-table-column prop="inspectionResult" width="120" align="center" label="检查结果">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.inspectionResult"
              disabled
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="ok"
              inactive-text="ng"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: "InspectionIncomingChildList",
    props: {
      // 接收检验明细数据
      inspectionReportVOS: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style scoped>
  /* 保持简洁，使用默认样式即可 */
</style>